const items = [
  "Santa Croce Camerina", "Marina di Ragusa", "Punta Secca", "Donnalucata",
  "Scicli", "Modica", "Ragusa Ibla", "Noto", "Val di Noto",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-amber-900/10 bg-sand-deep py-4" aria-hidden="true">
    <div className="flex w-max animate-marquee gap-0">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {items.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center">
              <span className="px-6 font-serif text-lg italic text-mare/80 sm:text-xl">{item}</span>
              <svg viewBox="0 0 64 64" width="14" height="14" aria-hidden="true">
                <g transform="translate(32 32)">
                  <g fill="#C85A32">
                    {[0, 60, 120, 180, 240, 300].map((r) => (
                      <ellipse key={r} cx="0" cy="-16" rx="7" ry="14" transform={`rotate(${r})`} />
                    ))}
                  </g>
                  <circle r="8" fill="#D99B26" />
                </g>
              </svg>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
